import { Box, Typography, Stepper, Step, StepLabel } from '@mui/material';
import ChatIcon from '@mui/icons-material/Chat';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import useStyles from './index.styles';

interface AccordianSummaryContentProps {
  title: string;
  steps: string[];
  activated: boolean;
}

const AccordianSummaryContent = ({
  title,
  steps,
  activated,
}: AccordianSummaryContentProps) => {
  const classes = useStyles();
  return (
    <Box width={'100%'}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          margin: '1rem 2rem',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: 5,
          }}
        >
          <div
            style={{
              height: '40px',
              width: '40px',
              background: '#2C62EC',
              display: 'grid',
              placeItems: 'center',
              borderRadius: '50%',
            }}
          >
            <ChatIcon style={{ color: '#fff' }} />
          </div>
          <Typography sx={{ marginLeft: '1rem', fontSize: '1.2rem' }}>
            {title}
          </Typography>
        </div>
        <div>
          {activated ? (
            <Typography sx={{ color: '#00BA34', fontSize: '1.2rem' }}>
              Activated
            </Typography>
          ) : (
            <button
              style={{
                background: '#FFB600',
                border: 'transparent',
                color: '#fff',
                padding: '8px 20px',
                fontSize: '1em',
                borderRadius: '20px',
                cursor: 'pointer',
              }}
            >
              Upgrade
            </button>
          )}
        </div>
      </Box>

      <Box
        style={{
          maxWidth: '300px',
          marginLeft: '45px',
          marginBottom: '10px',
        }}
      >
        <Stepper activeStep={0} alternativeLabel>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel
                StepIconComponent={CheckCircleIcon}
                classes={{
                  root: classes.stepperRoot,
                  iconContainer: classes.iconContainerStyle,
                  label: classes.customLabelStyle,
                }}
              >
                {label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>
    </Box>
  );
};

export default AccordianSummaryContent;
